var _excluded = ["checked", "className", "disabled", "id", "label", "onChange", "onMouseUp", "onTouchEnd", "size", "useSVG"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import { SVGIcon } from '@homeaway/react-svg';
import { CLOSE__16, CLOSE__24, CHECK__16, CHECK__24 } from '@homeaway/svg-defs';
import classNames from 'classnames';
import "./Switch.css";

function Switch(_ref) {
  var _classNames;

  var checked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      onMouseUp = _ref.onMouseUp,
      onTouchEnd = _ref.onTouchEnd,
      size = _ref.size,
      useSVG = _ref.useSVG,
      rest = _objectWithoutProperties(_ref, _excluded);

  var parentClasses = classNames(className, (_classNames = {
    switch: true
  }, _classNames["switch--" + size] = size, _classNames.disabled = !!disabled, _classNames));
  var smIcon = ['xs', 'sm'];
  return /*#__PURE__*/React.createElement("div", {
    className: parentClasses,
    role: "switch",
    "aria-checked": checked,
    onTouchEnd: onTouchEnd,
    onMouseUp: onMouseUp
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    id: id,
    onChange: onChange,
    checked: checked,
    disabled: disabled
  }, rest)), /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, useSVG && /*#__PURE__*/React.createElement(SVGIcon, {
    inline: true,
    className: "switch-checked text-white",
    markup: smIcon.indexOf(size) >= 0 ? CHECK__16 : CHECK__24
  }), useSVG && /*#__PURE__*/React.createElement(SVGIcon, {
    inline: true,
    className: "switch-unchecked text-white",
    markup: smIcon.indexOf(size) >= 0 ? CLOSE__16 : CLOSE__24
  }), /*#__PURE__*/React.createElement("div", {
    className: "switch-toggle"
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label));
}

Switch.propTypes = {
  /** Text label, can also contain other content if you need it. */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /** Mark the component as checked */
  checked: PropTypes.bool,

  /** id attribute for label */
  id: PropTypes.string.isRequired,

  /** Size variation from Baseline. Currently only one of: 'xs', 'sm' */
  size: PropTypes.oneOf(['xs', 'sm']),

  /** Called when the checked property changes */
  onChange: PropTypes.func,

  /** Should on and off state display SVG checkmark and X. */
  useSVG: PropTypes.bool
};
Switch.defaultProps = {
  onChange:
  /* istanbul ignore next */
  function onChange() {},
  useSVG: true
};
Switch.displayName = 'Switch';
export default Switch;
//# sourceMappingURL=Switch.js.map